import React from 'react';
import { withCampaignContainer } from "../../containers/shared/CampaignContainer";
import PageContainer from "./PageContainer";
// import {jsonContent} from "../../../utils/dump_2022_05_26"

const CampaignPagesContainer = (props) => {
  const pages = props && props.campaign && props.campaign.pages
  console.log(pages)

  return (
    <>
      {
        pages && pages.length > 0 &&
        pages.map((pageContent, key) => (
          <div key={key}>
            <PageContainer {...pageContent} />
          </div>
        ))
      }
    </>
  )
}
export default withCampaignContainer(CampaignPagesContainer);
